import React from "react";

const API_KEY = "Aqw4lvamTSKiw8gSzioEKz";

export const FILESTACK_CONTAINER_ID = "STORY_EDITOR_FILESTACK_CONTAINER_ID";

export default function Filestack({ onChange, ...props }) {
  if (typeof window !== "undefined") {
    const FilestackReact = require("filestack-react").default;

    return (
      <FilestackReact
        apikey={API_KEY}
        {...props}
        onSuccess={({ filesUploaded }) => {
          if (filesUploaded.length > 0) {
            onChange(filesUploaded[0].url);
          }
        }}
        actionOptions={{
          displayMode: "dropPane",
          container: FILESTACK_CONTAINER_ID,
          customText: {
            "Drag and Drop, Copy and Paste Files": "Click or Drag & Drop",
          },
        }}
        componentDisplayMode={{
          type: "immediate",
        }}
      />
    );
  }

  return null;
}
